/**
 * 成交公告列表页访问权限
 */
export const TRANSACTION_ANNOUNCEMENT_LIST_PAGE_UUID =
  '6e7f653f-5e5c-492d-a091-2868f0187df6'

/**
 * 预告管理权限
 */
export const TRANSACTION_ANNOUNCEMENT_LIST_ACTION_UUID =
  'abd89a32-fb78-4ceb-8a93-48ad429dfbcd'

/**
 * 频道管理权限
 */
export const TRANSACTION_ANNOUNCEMENT_CHANNEL_ACTION_UUID =
  'b9c1f54d-47c6-415d-b430-a3ef0575007d'
